import qs from 'qs';

export function getQsToken(query?: string) {
  if (!query) throw Error('Query must be provided to getQsToken');
  return qs.parse(query.slice(1)).t;
}
